import { Shop } from '../service/shop.interface';

export const shopsFilters: Shop = {
    name: null,
    limit: 3,
    offset: 0,
};
